import { createContext, useContext } from 'react';

const GlobalWindowContext = createContext(undefined);
const useWindow = (overrideNativeWindow) => {
    const globalWindow = useContext(GlobalWindowContext);
    if (globalWindow === undefined && !overrideNativeWindow) {
        return window;
    }
    else {
        return useContext(GlobalWindowContext);
    }
};

export { GlobalWindowContext, useWindow as default };
//# sourceMappingURL=useWindow.js.map
